/**
 * Event updated when dropdown value is changed
 */
export const ADVERTISING_OVERLAP_EVENT = 'advertisingOverlapEvent';
export const ADVERTISING_OVERLAP_ADTYPE_EVENT = 'advertisingOverlapAdTypeEvent';
